import { Analysis, Segmentation, SwingPosition } from './analysis.types';
import { SWING_POSITIONS } from './constants';
import { Nil } from './type-utils';

export function inferSwingPosition<T extends SwingPosition>(value: `${T}_${string}` | Nil): T | null;
export function inferSwingPosition<T extends SwingPosition>(value: `${string}_${T}_${string}` | Nil): T | null;
export function inferSwingPosition<T extends SwingPosition>(value: `${string}${T}${string}` | Nil): T | null;
export function inferSwingPosition<T extends SwingPosition>(value: `${string}_${T}` | Nil): T | null;
export function inferSwingPosition(value: string | Nil): SwingPosition | null;
export function inferSwingPosition(value: string | Nil): SwingPosition | null {
    // find 'p' followed by digits that is surrounded by non-word characters or start/end of the string
    return (value && (/(?<=^|[^a-z0-9])p\d+(?=[^a-z0-9]|$)/i.exec(value)?.[0].toLowerCase() as SwingPosition)) || null;
}

export function isSegmentationPosition(position: string): position is keyof Segmentation {
    return SWING_POSITIONS.some((swingPosition) => swingPosition.toUpperCase() === position);
}

export const getAnalysisParameterValue = (analysis: Analysis | null | undefined, paramId: string) => {
    return analysis?.data.analysis?.parameter_values?.[paramId]?.value;
};
